function colorFromName(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
  return `hsl(${h}, 35%, 38%)`;
}

function initials(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
}

export function PresenceDot({ name, title, size = 22 }) {
  return (
    <span
      title={title || name}
      style={{ width: size, height: size, background: colorFromName(name || ''), fontSize: size * 0.42 }}
      className="inline-flex items-center justify-center rounded-full text-white font-semibold ring-2 ring-white shrink-0"
    >
      {initials(name)}
    </span>
  );
}

export function PresenceList({ users, currentClientId }) {
  if (!users || users.length === 0) return null;
  const others = users.filter((u) => u.client_id !== currentClientId);
  if (others.length === 0) return (
    <div className="text-xs text-[#6A6D66]">Olet ainoa muokkaaja tässä päivässä.</div>
  );
  return (
    <div className="flex items-center gap-2 text-xs">
      <div className="flex -space-x-1.5">
        {others.slice(0, 5).map((u) => (
          <PresenceDot key={u.client_id} name={u.name} title={u.editing_customer_id ? `${u.name} muokkaa…` : u.name} />
        ))}
      </div>
      <span className="text-[#6A6D66]">
        {others.length} {others.length === 1 ? 'muu käyttäjä' : 'muuta käyttäjää'} verkossa
      </span>
    </div>
  );
}
